import Vue from 'vue';
import ConstantMap from 'config/constantMapConfig';

Vue.prototype.$ConstantMap = ConstantMap;
